import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { AdminState } from './types';
import { RootState } from '@/store/types';

export const state: AdminState = {
  whitelist: [],
  isWhitelistLoaded: false,
};

const namespaced = true;

export const admin: Module<AdminState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
